export const R2H_LIVEBLOG_CONFIG_PATH = "liveBlogR2HConfig"